module.exports = __webpack_public_path__ + "static/img/SG.39bfa15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certified_shipping/SG.png
// module id = /vlJ
// module chunks = 2